import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConversationUser } from '../models/chat.model';
import { PatchDocument } from '../models/patch.model';

@Injectable({
  providedIn: 'root',
})
export class ConversationUserService {
  updatableProperties: string[] = ['status'];

  path = '/api/ConversationUser';

  constructor(private http: HttpClient) {}

  updateConversationUser(body: ConversationUser): Observable<ConversationUser> {
    const url = `${environment.API}${this.path}/${body.id}`;
    const patchDoc = this.toPatchDoc(body);
    return this.http.patch<ConversationUser>(url, patchDoc, {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    });
  }

  protected toPatchDoc(object: ConversationUser): PatchDocument[] {
    let doc: PatchDocument[] = [];

    if (this.updatableProperties) {
      for (const [key, value] of Object.entries(object)) {
        if (this.updatableProperties.includes(key)) {
          doc.push({
            op: 'replace',
            path: `/${key}`,
            value: value,
          });
        }
      }
    }

    return doc;
  }

  protected buildQueryParameters(queryParameters?: Map<string, any>): string {
    if (queryParameters == null || queryParameters.size == 0) {
      return '';
    }

    let queryString = '?';

    for (let entry of queryParameters.entries()) {
      if (typeof entry[1] == 'object') {
        for (let val of Array.from(entry[1])) {
          queryString += entry[0] + '=' + val + '&';
        }

        queryString = queryString.substring(0, queryString.length - 1);
      } else {
        queryString += entry[0] + '=' + queryParameters.get(entry[0]);
      }
    }

    return queryString;
  }
}
